import {H2} from '@jetbrains/ring-ui/components/heading/heading'
import classNames from 'classnames'
import React, {useEffect} from 'react'

import {restApi} from '../../../../../services/rest'
import {emptyArray} from '../../../../../utils/empty'
import {subscribeOnBuildTypeEvents} from '../../../../../utils/subscriber'
import {
  BUILD_FINISHED,
  BUILD_INTERRUPTED,
  BUILD_STARTED,
  BUILD_TYPE_ADDED_TO_QUEUE,
  BUILD_TYPE_REMOVED_FROM_QUEUE,
} from '../../../../../utils/subscriptionEvents'
import type {pipelineHeadFragment$key} from '../../hooks/__generated__/pipelineHeadFragment.graphql'
import {usePipelineHead} from '../../hooks/pipeline'
import {usePipelineHistoryArg} from '../PipelinePage.hooks'

import PipelineRunLine from './PipelineRunLine/PipelineRunLine'

import styles from './PipelineHistory.css'

type Props = {pipelineHeadKey: pipelineHeadFragment$key | null}
export default function PipelineHistory({pipelineHeadKey}: Props) {
  const arg = usePipelineHistoryArg(pipelineHeadKey)
  const {runIds, refetch} = restApi.endpoints.getAllBuildsNormalized.useQuery(arg, {
    selectFromResult: ({data}) => ({
      runIds: data?.result ?? emptyArray,
    }),
  })
  const head = usePipelineHead(pipelineHeadKey)
  const headInternalId = head?.internalId
  useEffect(
    () =>
      headInternalId != null
        ? subscribeOnBuildTypeEvents(
            headInternalId,
            [
              BUILD_TYPE_ADDED_TO_QUEUE,
              BUILD_TYPE_REMOVED_FROM_QUEUE,
              BUILD_STARTED,
              BUILD_FINISHED,
              BUILD_INTERRUPTED,
            ],
            refetch,
          )
        : undefined,
    [headInternalId, refetch],
  )

  return runIds.length > 0 ? (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <H2 className={styles.title}>{'History'}</H2>
        <div className={styles.runs}>
          <div className={styles.columnHeader}>{'Run'}</div>
          <div className={styles.columnHeader}>{'Status'}</div>
          <div className={styles.columnHeader}>{'Branch'}</div>
          <div className={styles.columnHeader}>{'Changes'}</div>
          <div className={classNames(styles.columnHeader, styles.startDate)}>{'Start date'}</div>
          <div className={classNames(styles.columnHeader, styles.duration)}>{'Duration'}</div>
          <div className={styles.columnHeadersUnderline} />
          {runIds.map(runId => (
            <PipelineRunLine key={runId} runId={runId} pipelineHeadKey={pipelineHeadKey} />
          ))}
        </div>
      </div>
    </div>
  ) : null
}
